'use strict';

$(document).ready(function () {
    $('.custom-rich-text a').each(function () {
        var $link = $(this);

        // Add role="link" if missing
        if (!$link.attr('role')) {
            $link.attr('role', 'link');
        }

        // Add aria-label only if missing
        if (!$link.attr('aria-label')) {
            var text = $.trim($link.text());
            if (text.length > 0) {
                $link.attr('aria-label', text);
            }
        }
    });
});
